import { downgradeInjectable } from '@angular/upgrade/static';
import { GithubFacade } from '@mode/github/contract';
import * as angular from 'angular';

export const GithubDomainAngularJsModule = angular.module('github-domain-angularjs', [
  'mode.shared.services',
  'downgraded-ngrx-effects',
  'downgraded-shared-util-toast',
]).name;

angular.module(GithubDomainAngularJsModule).service('GithubFacade', downgradeInjectable(GithubFacade));
